<template>
  <div>
    <div class="form-group mb-0" v-show="showIfInactive ? row.membership_years && row.selectedSeason ? row.membership_years[row.selectedSeason].upgradeable && !!row.filtered_product_options.length : true : false">
      <select class="form-control" :id="'membershipType' + row.id" v-model="selected" @change="selectMembership()" :required="required">
        <option disabled></option>
        <option v-for="(membershipType, productsIndex) in row.filtered_product_options" :key="row.id + productsIndex" :value="membershipType.id">{{membershipType.name}}</option>
      </select>
      <div class="invalid-tooltip">Please include the Membership Type.</div>
    </div>
    <div v-show="!(showIfInactive ? row.membership_years && row.selectedSeason ? row.membership_years[row.selectedSeason].upgradeable && !!row.filtered_product_options.length : true : false)">{{ row.membership_years && row.selectedSeason ? row.membership_years[row.selectedSeason].name : '' }}</div>
  </div>
</template>

<script>
export default {
  props: ['row', 'options'],
  data() {
    return {
      selected: '',
      required: false,
      showIfInactive: this.options ? this.options.showIfInactive : false
    }
  },
  methods: {
    selectMembership() {
      let tempTypes = this.$store.state.renewMembershipTypes
      if (tempTypes.some(item => item.id === this.row.id)) {
        tempTypes = tempTypes.map((item) => {
          if (item.id === this.row.id) {
            item.membership_type = this.row.filtered_product_options.find(product => product.id === Number(this.selected))
          }
          return item
        })
      } else {
        const tempItem = this.row
        tempItem.membership_type = this.row.filtered_product_options.find(product => product.id === Number(this.selected))
        tempTypes.splice(0, 0, tempItem)
      }
      this.$store.commit('updateRenewMembershipTypes', tempTypes)
      if (!this.$store.getters.getRowState(this.row.id)) {
        this.$store.commit('updateSelectedRows', this.row)
      }
      this.$store.commit('rowsUpdatedToggle')
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (!this.$store.getters.getRowState(this.row.id)) {
        this.selected = ''
      } else {
        this.selected = this.$store.getters.selectedRows.find(theRow => theRow.id === this.row.id).typeId
        this.selectMembership()
      }
    })
  },
  computed: {
    selectedRows: {
      get() {
        const theRows = this.$store.getters.selectedRows
        return theRows
      }
    }
  },
  watch: {
    selectedRows: {
      deep: true,
      handler(theRows) {
        this.required = theRows.some(theRow => theRow.id === this.row.id)
        if (!this.$store.getters.getRowState(this.row.id)) {
          this.selected = ''
        }
      }
    },
    row: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          const theRow = this.selectedRows.some(row => row.id === this.row.id)
          this.selected = theRow ? theRow.typeId ? theRow.typeId : '' : ''
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DataTableFields/Dropdown.vue